import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-crud-form-header',
  standalone: true,
  imports: [],
  templateUrl: './crud-form-header.component.html',
  styleUrl: './crud-form-header.component.scss',
})
export class CrudFormHeaderComponent {
  @Input() id: number = -1;
  @Input() disable: boolean = false;
  @Input() title: string = '';
  @Input() newA: boolean = false;

  ngOnInit(): void {
    if (this.disable && this.title) {
      this.title = this.title.charAt(0).toUpperCase() + this.title.substring(1)
    }
  }
}
